/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useMemo } from 'react';
import axios from 'axios';
// Datatables
import $ from 'jquery';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css';
import 'datatables.net-bs4';
import 'datatables.net-buttons-bs4';
import 'datatables.net-buttons/js/buttons.html5.js';
import '../../dtButtons.css';
// MUI
import Box from '@material-ui/core/Box';
// Components
import Spinner from '../../components/Spinner';
import HistoryIcon from './history.svg';

function statusRender(data) {
  if (data === 17) {
    return `<span style='border-radius: 5px; padding: 5px; background-color: rgb(30, 146, 244); color: rgb(235 246 255); border: none;'>Paused</span>`;
  } else if (data === 1) {
    return `<span style='border-radius: 5px; padding: 5px; background-color: rgb(196, 248, 226); color: rgb(6, 165, 97); border: none;'>Active</span>`;
  } else if (data === 2) {
    return `<span style='border-radius: 5px; padding: 5px; background-color: rgb(223, 223, 223); color: rgb(173, 173, 173); border: none;'>Deleted</span>`;
  } else {
    return `<span style='border-radius: 5px; padding: 5px; background-color: rgb(255, 244, 201); color: rgb(249, 150, 0); border: none;'>Inactive</span>`;
  }
}

const TriggerList = ({
  rows,
  isLoading,
  totalPages,
  totalElements,
  onQueryChange,
}) => {
  const tableRef = useRef(null);
  const [render, setRender] = useState(false);

  const columns = useMemo(
    () => [
      {
        title: `<img src="${HistoryIcon}" alt="Edit" style="width:30px; height:30px; border-radius:4px;"/>`,
        className: 'dt-control',
        orderable: false,
        data: null,
        defaultContent: '',
        width: '30px',
      },
      {
        title: 'ID',
        data: 'id',
        width: '80px',
        render: function (data) {
          return `<a href="/trigger-manager/${data}/edit">${data}</a>`;
        },
      },
      { title: 'Partner', data: 'partner_name', width: '250px' },
      { title: 'Name', data: 'name', width: '290px' },
      { title: 'Description', data: 'description', width: '300px' },
      { title: 'Integration', data: 'integration_name', width: '200px' },
      {
        title: 'Date Created',
        data: 'date_created',
        width: '200px',
        render: function (data) {
          return dateFormats(data);
        },
      },
      {
        title: 'Date Updated',
        data: 'date_updated',
        width: '200px',
        render: function (data) {
          return dateFormats(data);
        },
      },
      {
        title: 'Status',
        data: 'status',
        width: '135px',
        render: function (data) {
          if (data === 17) {
            return `<span style='border-radius: 5px; padding: 5px; background-color: rgb(30, 146, 244); color: rgb(235 246 255); border: none;'>System Paused</span>`;
          } else if (data === 1) {
            return `<span style='border-radius: 5px; padding: 5px; background-color: rgb(196, 248, 226); color: rgb(6, 165, 97); border: none;'>Active</span>`;
          } else if (data === 2) {
            return `<span style='border-radius: 5px; padding: 5px; background-color: rgb(223, 223, 223); color: rgb(173, 173, 173); border: none;'>Deleted</span>`;
          } else {
            return `<span style='border-radius: 5px; padding: 5px; background-color: rgb(255, 244, 201); color: rgb(249, 150, 0); border: none;'>Inactive</span>`;
          }
        },
      },
      {
        title: 'Subscriber Limit Count',
        data: 'subscriber_limit_count',
        render: function (data) {
          return data ? data : '-';
        },
      },
      {
        title: 'Delete Contact After Fire',
        data: 'delete_contact_after_fire',
        width: '100px',
        render: function (data) {
          return data === 1 ? 'ON' : 'OFF';
        },
      },
      {
        title: 'Trigger Limit Status',
        data: 'daily_trigger_limit_on',
        width: '100px',
        render: function (data) {
          return data === 1 ? 'ON' : 'OFF';
        },
      },
      {
        title: 'Daily Trigger Limit',
        data: 'daily_trigger_limit',
        width: '100px',
      },
      {
        title: 'One Time Per user',
        data: 'one_time_per_user',
        width: '100px',
        render: function (data) {
          return data ? 'True' : 'False';
        },
      },
    ],
    [],
  );

  const getParamsFromURL = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const params = {};

    params.draw = parseInt(urlParams.get('draw')) || 1;
    params.start = parseInt(urlParams.get('start')) || 0;
    params.length = parseInt(urlParams.get('length')) || 25; // Updated to default to 25

    const order = urlParams.get('order');
    if (order) {
      params.order = JSON.parse(order);
    }

    const search = urlParams.get('search');
    if (search) {
      params.search = JSON.parse(search);
    }

    return params;
  };

  const fetchData = async params => {
    params.star = 1; // Ensure the 'star' param is included
    const urlParams = getParamsFromURL();

    const mergedParams = { ...urlParams, ...params };

    const { columns, ...paramsWithoutColumns } = mergedParams;
    const serializedParams = {};

    for (let key in paramsWithoutColumns) {
      if (paramsWithoutColumns.hasOwnProperty(key)) {
        if (typeof paramsWithoutColumns[key] === 'object') {
          serializedParams[key] = JSON.stringify(paramsWithoutColumns[key]);
        } else {
          serializedParams[key] = paramsWithoutColumns[key];
        }
      }
    }

    const queryString = new URLSearchParams(serializedParams).toString();
    const newUrl = `${window.location.pathname}?${queryString}`;
    window.history.replaceState(null, '', newUrl);
    if (mergedParams.order.length > 0 && mergedParams.order[0]?.column > 0) {
      mergedParams.order[0].column -= 1;
    }
    const response = await axios.post(
      `/triggers/datatables?datatables=admin`,
      mergedParams,
    );
    return response;
  };

  const dateFormats = dateString => {
    if (!dateString) return 'N/A';

    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${month}-${day}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const format = d => {
    if (!d.logs || d.logs.length === 0) {
      return '<hr style="border: 1px solid #000;"><strong>No logs available.</strong><hr style="border: 1px solid #000;">';
    }

    return `
      <div style="background-color: #f0f0f0; padding: 10px; border-radius: 5px;">
        <table style="width: 100%; border-collapse: collapse; font-size: 14px; border-bottom: 2px solid #000; margin-bottom: 20px; margin-top: 5px; table-layout: auto;">
          <thead>
            <tr style="border-bottom: 2px solid #666;">
              <th style="word-wrap: break-word; white-space: normal; padding: 10px; width: 150px;">Log Name</th>
              <th style="word-wrap: break-word; white-space: normal; padding: 10px; width: 100px;">Status</th>
              <th style="word-wrap: break-word; white-space: normal; padding: 10px; width: 130px;">Daily Spend Cap</th>
              <th style="word-wrap: break-word; white-space: normal; padding: 10px; width: 130px;">Daily Spend Total</th>
              <th style="word-wrap: break-word; white-space: normal; padding: 10px; width: 130px;">Daily Trigger Limit</th>
              <th style="word-wrap: break-word; white-space: normal; padding: 10px; width: 200px;">Date Updated</th>
              <th style="word-wrap: break-word; white-space: normal; padding: 10px; width: 120px;">Entity ID</th>
              <th style="word-wrap: break-word; white-space: normal; padding: 10px; width: 150px;">Integration ID</th>
              <th style="word-wrap: break-word; white-space: normal; padding: 10px; width: 150px;">Last System Pause</th>
              <th style="word-wrap: break-word; white-space: normal; padding: 10px; width: 120px;">Partner ID</th>
              <th style="word-wrap: break-word; white-space: normal; padding: 10px; width: 180px;">Subscriber Hour Interval</th>
              <th style="word-wrap: break-word; white-space: normal; padding: 10px; width: 200px;">Subscriber Limit Time Period</th>
              <th style="word-wrap: break-word; white-space: normal; padding: 10px; width: 150px;">Trigger Method</th>
              <th style="word-wrap: break-word; white-space: normal; padding: 10px; width: 100px;">Log ID</th>
            </tr>
          </thead>
          <tbody>
            ${d.logs
              .map(
                log => `
              <tr style="border-bottom: 1px solid #ccc;">
                <td style="word-wrap: break-word; white-space: normal; padding: 10px 2px; width: 150px;">${
                  log.name ? `${log.name}` : 'N/A'
                }</td>
                <td style="word-wrap: break-word; white-space: normal; padding: 10px 2px; width: 100px;">
                ${statusRender(log.status)}
                </td>
                <td style="word-wrap: break-word; white-space: normal; padding: 10px 2px; width: 130px;">${
                  log.daily_spend_cap !== undefined
                    ? log.daily_spend_cap
                    : 'N/A'
                }</td>
                <td style="word-wrap: break-word; white-space: normal; padding: 10px 2px; width: 130px;">${
                  log.daily_spend_total !== undefined
                    ? log.daily_spend_total
                    : 'N/A'
                }</td>
                <td style="word-wrap: break-word; white-space: normal; padding: 10px 2px; width: 130px;">${
                  log.daily_trigger_limit ? log.daily_trigger_limit : 'N/A'
                }</td>
                <td style="word-wrap: break-word; white-space: normal; padding: 10px 2px; width: 150px;">${
                  log.date_updated ? dateFormats(log.date_updated) : 'N/A'
                }</td>
                <td style="word-wrap: break-word; white-space: normal; padding: 10px 2px; width: 120px;">${
                  log.entity_id ? log.entity_id : 'N/A'
                }</td>
                <td style="word-wrap: break-word; white-space: normal; padding: 10px 2px; width: 150px;">${
                  log.integration_id !== undefined ? log.integration_id : 'N/A'
                }</td>
                <td style="word-wrap: break-word; white-space: normal; padding: 10px 2px; width: 150px;">${
                  log.last_system_pause !== null
                    ? dateFormats(log.last_system_pause)
                    : 'N/A'
                }</td>
                <td style="word-wrap: break-word; white-space: normal; padding: 10px 2px; width: 120px;">${
                  log.partner_id !== undefined ? log.partner_id : 'N/A'
                }</td>
                <td style="word-wrap: break-word; white-space: normal; padding: 10px 2px; width: 180px;">${
                  log.subscriber_hour_interval !== undefined
                    ? log.subscriber_hour_interval
                    : 'N/A'
                }</td>
                <td style="word-wrap: break-word; white-space: normal; padding: 10px 2px; width: 200px;">${
                  log.subscriber_limit_time_period !== null
                    ? log.subscriber_limit_time_period
                    : 'N/A'
                }</td>
                <td style="word-wrap: break-word; white-space: normal; padding: 10px 2px; width: 150px;">${
                  log.trigger_method ? log.trigger_method : 'N/A'
                }</td>
                <td style="word-wrap: break-word; white-space: normal; padding: 10px 2px; width: 100px;">${
                  log.id !== undefined ? log.id : 'N/A'
                }</td>
              </tr>
            `,
              )
              .join('')}
          </tbody>
        </table>
      </div>
    `;
  };

  const initializeDataTable = () => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy();
    }

    const initialParams = getParamsFromURL();

    const table = $(tableRef.current).DataTable({
      serverSide: true,
      processing: true,
      columns: columns,
      dom: '<"d-flex align-items-center dt-controls"lB>rtip',
      responsive: true,
      scrollX: true,
      displayStart: initialParams.start || 0,
      pageLength: initialParams.length || 25, // Updated to default to 25
      order: initialParams.order || [[7, 'desc']],
      search: initialParams.search || { value: '', regex: false },
      ajax: (data, callback, settings) => {
        fetchData(data)
          .then(result => {
            const recordsFiltered = result.recordsFiltered || 0;
            const recordsTotal = result.recordsTotal || 0;

            callback({
              draw: data.draw,
              recordsTotal: recordsTotal,
              recordsFiltered: recordsFiltered,
              data: result.data,
            });
          })
          .catch(error => {
            console.error('Error fetching data: ', error);
            callback({
              draw: data.draw,
              recordsTotal: 0,
              recordsFiltered: 0,
              data: [],
            });
          });
      },
      buttons: [
        {
          extend: 'csv',
          text: 'Export',
          action: function (e, dt, node, config) {
            fetchAllDataAndExport();
          },
        },
      ],
      language: {
        infoFiltered: '',
      },
      initComplete: function () {
        const api = this.api();

        // Iterate over each column to add search inputs
        api.columns().every(function (index) {
          if (index === 0) {
            return;
          }
          const column = this;

          // Create a wrapper for the search input
          const wrapper = $(
            '<div class="column-search-wrapper" style="margin-top: 5px; width: 90%; margin-left: -10px;"></div>',
          );
          const searchInput = $(
            '<input type="text" class="column-search" placeholder="Search" style="width: 100%; box-sizing: border-box; padding: 4px;"/>',
          )
            .on('click', function (e) {
              e.stopPropagation(); // Prevent triggering column sorting when clicking the search input
            })
            .on(
              'keyup change clear',
              debounce(function () {
                const searchValue = this.value;
                if (column.search() !== searchValue) {
                  column.search(searchValue).draw(false); // Update search without resetting sort state
                }
              }, 500),
            );

          wrapper.append(searchInput);
          $(column.header()).append(wrapper);

          // Set the initial search value from the URL or state
          const state = api.state();
          const initialSearchValue =
            state?.columns?.[index]?.search?.search || '';
          if (initialSearchValue) {
            searchInput.val(initialSearchValue);
            column.search(initialSearchValue);
          }
        });

        // Prevent column header sorting from being triggered by the search inputs
        $(this).on('click', 'thead th', function (e) {
          const colIdx = $(this).index();
          if (!$(this).hasClass('sorting_disabled')) {
            api.order([[colIdx, 'asc']]).draw(); // Enable sorting explicitly when column header is clicked
          }
        });
        // Apply styles immediately after the DOM is updated
        setTimeout(() => {
          applyCustomStyles(api);
        }, 0);
      },

      drawCallback: function (settings) {
        const api = this.api();
        applyCustomStyles(api);

        const searchColumns = api
          .columns()
          .data()
          .toArray()
          .map((col, index) => {
            const searchValue = api.column(index).search();
            return {
              index: index,
              name: col.sName || col.name, // Depending on how you define columns
              searchValue: searchValue,
            };
          });

        const draw = settings.iDraw || initialParams.draw;
        const start = settings._iDisplayStart;
        const length = settings._iDisplayLength || 25; // Updated to default to 25
        const order = api.order();
        const search = api.search();

        const queryString = new URLSearchParams({
          draw: draw,
          start: start,
          length: length,
          order: JSON.stringify(order),
          search: JSON.stringify(searchColumns),
        }).toString();

        const newUrl = `${window.location.pathname}?${queryString}`;
        window.history.replaceState(null, '', newUrl);
      },
    });

    // Add event listener for opening and closing details
    $(tableRef.current).on('click', 'td.dt-control', function () {
      const tr = $(this).closest('tr');
      const row = table.row(tr);

      if (!row.node()) {
        console.error('Failed to get row node.');
        return;
      }

      if (row.child.isShown()) {
        // This row is already open - close it
        row.child.hide();
        tr.removeClass('shown');
      } else {
        // Open this row
        row.child(format(row.data())).show();
        tr.addClass('shown');
      }
    });
  };

  const debounce = (func, delay) => {
    let debounceTimer;
    return function (...args) {
      const context = this;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  useEffect(() => {
    const initialParams = getParamsFromURL();

    if (!initialParams.draw) {
      const initialDrawParams = {
        draw: 1,
        start: 0,
        length: 25, // Updated to default to 25
        order: JSON.stringify([[7, 'desc']]),
        search: JSON.stringify({ value: '', regex: false }),
      };
      const queryString = new URLSearchParams(initialDrawParams).toString();
      const newUrl = `${window.location.pathname}?${queryString}`;
      window.history.replaceState(null, '', newUrl);
    }

    initializeDataTable();

    // Debounce resize event handler
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
          const table = $(tableRef.current).DataTable();
          table.columns.adjust().draw(); // Adjust and redraw columns without reinitializing the table
        }
      }, 200);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
  }, [columns, render]);

  async function fetchAllDataAndExport() {
    const table = $(tableRef.current).DataTable();
    const params = table.ajax.params();

    try {
      const response = await axios.post(
        '/triggers/datatables?datatables=admin&export=admin',
        params,
      );
      if (response.data && response.data.length > 0) {
        const csvData = convertToCSV(response.data);
        downloadCSV(csvData, 'export.csv');
        setRender(!render);
      }
    } catch (error) {
      console.error('Error fetching data for export:', error);
    }
  }

  function convertToCSV(data) {
    const csvRows = [];
    const headers = Object.keys(data[0] || {});
    csvRows.push(headers.join(','));

    for (const row of data) {
      const values = headers.map(header => {
        const val = row[header];
        return typeof val === 'string' ? `"${val.replace(/"/g, '""')}"` : val;
      });
      csvRows.push(values.join(','));
    }

    return csvRows.join('\n');
  }

  function downloadCSV(csvData, filename) {
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  function applyCustomStyles(api) {
    $(api.table().container())
      .find('label, input, select, th, td, .dt-info')
      .css({
        'font-size': '14px',
        'font-weight': 'bold',
      });
    $(api.table().container()).find('label').css({
      padding: '5px',
    });
    $(api.table().container()).find('input, select').css({
      margin: '10px',
    });
    $(api.table().container()).find('thead tr th').css({
      'padding-left': '10px',
      'text-align': 'left',
      'border-bottom': '2px solid #dee2e6',
      'border-right': '1px solid #dee2e6',
    });
    $(api.table().container()).find('tfoot tr th').css({
      'border-bottom': '2px solid #dee2e6',
    });
    $(api.table().container()).find('tbody tr td').css({
      'padding-left': '10px',
      'border-bottom': '1px solid #dee2e6',
      'border-right': '1px solid #dee2e6',
      'white-space': 'normal',
      overflow: 'hidden',
      'text-overflow': 'ellipsis',
    });
    $(api.table().container())
      .find('tbody tr td:last-child, thead tr th:last-child')
      .css({
        'border-right': 'none',
      });
    $(api.table().container())
      .find(
        '.DTFC_LeftWrapper table th, .DTFC_LeftWrapper table td, .DTFC_Cloned th, .DTFC_Cloned td',
      )
      .css({
        'border-right': '1px solid #dee2e6',
        'background-color': 'inherit',
      });
    $(api.table().container())
      .find(
        '.DTFC_LeftWrapper table th:last-child, .DTFC_LeftWrapper table td:last-child, .DTFC_Cloned th:last-child, .DTFC_Cloned td:last-child',
      )
      .css({
        'border-right': 'none',
      });
    $(api.table().container())
      .find('.DTFC_Cloned th:last-child, .DTFC_Cloned td:last-child')
      .css({
        'box-shadow': '10px 0 5px -2px rgba(0, 0, 0, 0.3)',
      });

    $(api.table().container()).find('ul.pagination').css({
      display: 'flex',
      justifyContent: 'center',
      padding: '0',
      marginTop: '10px',
      listStyle: 'none',
    });

    $(api.table().container()).find('ul.pagination li').css({
      display: 'inline',
      margin: '0 2px',
    });

    $(api.table().container()).find('ul.pagination li a').css({
      display: 'inline-block',
      padding: '5px 10px',
      border: '1px solid #ddd',
      borderRadius: '5px',
      textDecoration: 'none',
      color: '#333',
    });

    $(api.table().container()).find('ul.pagination li.active a').css({
      backgroundColor: '#E00001',
      color: 'white',
    });

    $(api.table().container()).find('ul.pagination li a:hover').css({
      backgroundColor: '#f1f1f1',
      color: '#333',
    });

    $(api.table().container()).find('.dt-controls').css({
      display: 'flex',
      justifyContent: 'flex-start', // Aligns controls to the left
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
      gap: '15px', // Add some space between elements if needed
    });

    $(api.table().container()).find('input[id^="dt-search-"]').css({
      height: '2.5rem',
      width: '15rem',
    });

    $(api.table().container()).find('select[id^="dt-length-"]').css({
      height: '2.5rem',
      width: '3rem',
    });

    $(api.table().container()).find('div.dt-length').css({
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    });

    $(api.table().container()).find('div.dt-search').css({
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    });

    $(api.table().container()).find('.buttons-html5, .buttons-print').css({
      'background-color': '#E00001',
      'border-width': '2px',
      'border-radius': '10px',
      'border-color': '#E00001',
      color: 'white',
      padding: '10px',
      cursor: 'pointer',
      'font-size': '1rem',
    });
  }

  return (
    <>
      <Box>
        <table ref={tableRef} className="display" />
      </Box>
      {isLoading && (
        <Box display="flex" paddingTop={2} justifyContent="center">
          <Spinner />
        </Box>
      )}
    </>
  );
};

export default TriggerList;
